import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import FeaturedEventCard from "./FeaturedEventCard";

export default function FeaturedEventsList({ events, loading, onNavigate }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2 }}
      className="flex flex-col items-center lg:items-start"
    >
      <div className="flex flex-col items-center mb-6 w-full lg:items-start">
        <h2 className="mb-2 text-2xl font-bold text-gray-900">Featured Events</h2>
        <motion.button
          onClick={() => onNavigate("/conference-trade-mission")}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="flex gap-1 items-center text-sm font-semibold text-orange-600 transition-colors hover:text-orange-700"
        >
          See all
          <ArrowRight size={14} />
        </motion.button>
      </div>

      {loading ? (
        <div className="flex justify-center items-center py-8 w-full">
          <div className="w-8 h-8 rounded-full border-2 border-orange-500 animate-spin border-t-transparent" />
        </div>
      ) : events.length === 0 ? (
        <div className="py-8 w-full text-center">
          <p className="text-sm text-gray-600">
            No featured events available at the moment.
          </p>
        </div>
      ) : (
        <div className="space-y-3 w-full">
          {events.slice(0, 4).map((event, index) => (
            <FeaturedEventCard
              key={event.slug || index}
              event={event}
              index={index}
              onNavigate={onNavigate}
            />
          ))}
        </div>
      )}
    </motion.div>
  );
}

